











module.exports =
  props:
    moves: required: true
  data: ->
    i18n: require '../i18n'
  watch:
    moves: -> @$nextTick => @$refs.input.scrollLeft = 9999

